import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function Cookies() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Cookie Policy" subtitle={`How ${COMPANY.website} uses cookies and similar technologies.`} />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>1. What Are Cookies?</h2>
        <p>Cookies are small text files stored on your device by your web browser when you visit a website. They allow the site to remember information about your visit, such as preferred language and other settings, which can make your next visit easier and the site more useful to you.</p>

        <h2>2. How We Use Cookies</h2>
        <ul>
          <li><strong>Essential cookies</strong> — required for the site to function correctly (e.g., session management, security).</li>
          <li><strong>Analytics cookies</strong> — help us understand how visitors interact with the site so we can improve it.</li>
          <li><strong>Preference cookies</strong> — remember your choices such as language or region.</li>
          <li><strong>Marketing cookies</strong> — may be used to measure the effectiveness of our advertising campaigns.</li>
        </ul>

        <h2>3. Third-Party Cookies</h2>
        <p>We may allow selected third parties (such as analytics or advertising partners) to place cookies on your device. These cookies are governed by the third party&apos;s privacy policies.</p>

        <h2>4. Managing Cookies</h2>
        <p>You can control and delete cookies through your browser settings. Most browsers accept cookies by default, but you can typically modify your browser settings to decline them. Note that disabling cookies may impact site functionality.</p>

        <h2>5. Changes to This Policy</h2>
        <p>We may update this Cookie Policy from time to time. Please revisit this page periodically for the latest information.</p>

        <h2>6. Contact</h2>
        <p>Questions? Email us at <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.</p>
      </LegalBody>
    </>
  );
}
